import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Moment from 'react-moment';
import { withRouter } from 'react-router-dom';

import Loading from '../components/Loading';
import API from '../api/ApiTool';


const LogsTable = (props) => {
  return (
    <div>
      <Table style={{backgroundColor: "#0f172a"}}>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={props.property === 'company'}
                direction={props.getDirection('company')}
                onClick={() => props.handleSort('company')}
              >
                Company
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'country_code_searched'}
                direction={props.getDirection('country_code_searched')}
                onClick={() => props.handleSort('country_code_searched')}
              >
                Country
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'area_code_searched'}
                direction={props.getDirection('area_code_searched')}
                onClick={() => props.handleSort('area_code_searched')}
              >
                Area code
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'is_searching_toll_free'}
                direction={props.getDirection('is_searching_toll_free')}
                onClick={() => props.handleSort('is_searching_toll_free')}
              >
                Toll free
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'timestamp'}
                direction={props.getDirection('timestamp')}
                onClick={() => props.handleSort('timestamp')}
              >
                Timestamp
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'telnyx_results_count'}
                direction={props.getDirection('telnyx_results_count')}
                onClick={() => props.handleSort('telnyx_results_count')}
              >
                Telnyx
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'twilio_results_count'}
                direction={props.getDirection('twilio_results_count')}
                onClick={() => props.handleSort('twilio_results_count')}
              >
                Twilio
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'telnyx_results_count'}
                direction={props.getDirection('telnyx_results_count')}
                onClick={() => props.handleSort('telnyx_results_count')}
              >
                Plivo
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data.results.map((log, i) => {
            return (
              <TableRow key={i}>
                <TableCell>
                  <a style={{cursor: 'pointer', color: '#3b82f6'}}
                    onClick={() => {props.push(`/company-detail/${log.company.id}`)}}>
                    {log.company.name}
                  </a>
                </TableCell>
                <TableCell>{log.country_code_searched}</TableCell>
                <TableCell>{log.area_code_searched}</TableCell>
                <TableCell>{ log.is_searching_toll_free ? 'True' : 'False' }</TableCell>
                <TableCell>
                  <Moment format="YYYY/MM/DD">
                    {log.timestamp}
                  </Moment>
                </TableCell>
                <TableCell>{log.telnyx_results_count}</TableCell>
                <TableCell>{log.twilio_results_count}</TableCell>
                <TableCell>{log.plivo_results_count}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <div>
        {props.loadingMore
          ?
            <p style={{color: '#94a3b8', fontFamily: '"Inter", system-ui, sans-serif', marginLeft: '15px'}}>
              Loading more...
            </p>
          :
            undefined
        }
      </div>
    </div>
  );
};


class SearchNumberLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      property: 'timestamp',
      order: 'asc',
      loadingMore: false
    };

    window.onscroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop
        === document.documentElement.offsetHeight
      ) {
        if (Object.keys(this.state.data).length !== 0 && !this.state.loadingMore) {
          this.fetchData(this.state.data.next);
        }
      }
    };
  }

  fetchData(paginationURL) {
    let property = this.state.property;
    const direction = this.state.order;

    if (direction === 'asc') {
      property = '-' + property;
    }

    if (!paginationURL) {
      this.setState({ loading: true });
      let url = undefined;
      if (!this.props.match.params.id) {
        url = `/bridges/search-numbers-logs/?ordering=${property}&limit=25`;
      }
      else {
        const id = this.props.match.params.id;
        url = `/bridges/search-numbers-logs/?ordering=${property}&filter-company=${id}&limit=25`;
      }
      API.GET(url)
        .then(response => response.json())
        .then(data => this.setState({ data }))
        .then(() => this.setState({ loading: false }))
    }
    else {
      this.setState({ loadingMore: true });
      API.GET(paginationURL)
        .then(response => response.json())
        .then(data => {
          let logs = this.state.data;
          logs.results = logs.results.concat(data.results);
          logs.next = data.next;
          this.setState({ data: logs });
        })
        .then(() => this.setState({ loadingMore: false }))
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  companyDetail(id, push) {
    push(`/company-detail/${id}`);
  }

  handleSort(property) {
    if (property === this.state.property && this.state.order === 'asc') {
      this.setState({ order: 'desc' }, () => {
        this.fetchData();
      });
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      this.setState({ order: 'asc' }, () => {
        this.fetchData();
      });
    }
    else {
      this.setState({ property: property }, () => {
        this.setState({ order: 'asc' }, () => {
          this.fetchData();
        });
      });
    }
  }

  getDirection(property) {
    let order = 'asc';
    if (property === this.state.property && this.state.order === 'asc') {
      order = 'asc';
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      order = 'desc';
    }
    return order;
  }

  render() {
    const { data, loading } = this.state;

    if (loading) {
      return (
        <Loading />
      );
    }

    return (
      <div>
        <LogsTable
          data={data}
          push={this.props.history.push}
          companyDetail={this.companyDetail.bind(this)}
          handleSort={this.handleSort.bind(this)}
          getDirection={this.getDirection.bind(this)}
          property={this.state.property}
          loadingMore={this.state.loadingMore}
        />
      </div>
    );
  }
}

export default withRouter(SearchNumberLogs);



// WEBPACK FOOTER //
// ./src/pages/SearchNumberLogs.js